<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M14.672 30.667a1 1 0 00.476-.12 1.02 1.02 0 00.432-.264l2.505-2.566c.128-.13.215-.287.261-.452a1.07 1.07 0 00.1-.446l.07-12.808 7.85-8.039a1.07 1.07 0 00-.1-1.577A1.017 1.017 0 0025.465 4H6.62a1.01 1.01 0 00-.689.271 1.043 1.043 0 00-.297.213 1.07 1.07 0 000 1.488l8.01 8.203v15.439c0 .581.46 1.053 1.028 1.053z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsFunnelFilled'
}
</script>
